export const SITE = {
  name: "Marble & Veil",
  email: "hello@marbleandveil.com",
  phone: "760-701-5970",
  phoneHref: "tel:+17607015970",
  address: "9528 Miramar Rd #1243, San Diego, CA 92126",
  tagline: "Beautiful wedding details, thoughtfully brought together.",
  region: "Southern California",
  owners: "Sandra & Nathan · Alexandra & Roman",
};

export const IMG = {
  hero: "https://images.pexels.com/photos/7289124/pexels-photo-7289124.jpeg?auto=compress&cs=tinysrgb&w=1600",
  oilArt1: "https://images.pexels.com/photos/8792976/pexels-photo-8792976.jpeg?auto=compress&cs=tinysrgb&w=1200",
  oilArt2: "https://images.unsplash.com/photo-1579783901586-d88db74b4fe4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  oilArt3: "https://images.unsplash.com/photo-1579783900882-c0d3dad7b119?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  story: "https://images.unsplash.com/photo-1596457221755-b96bc3a6df18?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  veil: "https://images.unsplash.com/photo-1519741196428-6a2175fa2557?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  embrace: "https://images.unsplash.com/photo-1517456363055-5d162a453d6d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  tablescape: "https://images.unsplash.com/photo-1758810741375-0fea503c9cbd?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  longTable: "https://images.unsplash.com/photo-1758810743028-6b8e150ec98f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  gardenTable: "https://images.unsplash.com/photo-1758810741900-0b2250ded8b3?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  estate: "https://images.unsplash.com/photo-1787089880833-816a9226194f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  aisle: "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  reception: "https://images.pexels.com/photos/34542755/pexels-photo-34542755.jpeg?auto=compress&cs=tinysrgb&w=1200",
  vintageGlass: "https://images.pexels.com/photos/37423116/pexels-photo-37423116.jpeg?auto=compress&cs=tinysrgb&w=1200",
  drapery: "https://images.pexels.com/photos/37558706/pexels-photo-37558706.jpeg?auto=compress&cs=tinysrgb&w=1200",
  glassware: "https://images.unsplash.com/photo-1502635385003-ee1e6a1a742d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  stationery: "https://images.unsplash.com/photo-1647470225155-f095a308d959?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  envelope: "https://images.unsplash.com/photo-1632610992723-82d7c212f6d7?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  waxSeal: "https://images.pexels.com/photos/4554087/pexels-photo-4554087.jpeg?auto=compress&cs=tinysrgb&w=1200",
  flatlay: "https://images.unsplash.com/photo-1710961716482-2e9bbc146e73?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  perfume: "https://images.pexels.com/photos/7598170/pexels-photo-7598170.jpeg?auto=compress&cs=tinysrgb&w=1200",
  perfumeDetail: "https://images.pexels.com/photos/7060421/pexels-photo-7060421.jpeg?auto=compress&cs=tinysrgb&w=1200",
  dance: "https://images.pexels.com/photos/6266941/pexels-photo-6266941.jpeg?auto=compress&cs=tinysrgb&w=1200",
  sparklerExit: "https://images.pexels.com/photos/30505264/pexels-photo-30505264.jpeg?auto=compress&cs=tinysrgb&w=1200",
  bouquet: "https://images.unsplash.com/photo-1625038032128-54ed70feb167?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  bouquetChair: "https://images.unsplash.com/photo-1700142611715-8a023c5eb8c5?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  bouquetHands: "https://images.unsplash.com/photo-1731994710373-849feb905390?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  brideVeil: "https://images.pexels.com/photos/7289124/pexels-photo-7289124.jpeg?auto=compress&cs=tinysrgb&w=1200",
  vintage: "https://images.unsplash.com/photo-1471363159950-bc68f8be7abb?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  welcomeSign: "https://images.pexels.com/photos/14608916/pexels-photo-14608916.jpeg?auto=compress&cs=tinysrgb&w=1200",
  familyTable: "https://images.unsplash.com/photo-1762220298545-865e5d3eda5f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
};

export const GALLERY = [
  { src: IMG.veil, caption: "The veil moment", tag: "Design inspiration" },
  { src: IMG.tablescape, caption: "Linen, crystal, quiet florals", tag: "Design inspiration" },
  { src: IMG.bouquet, caption: "White florals, chosen quietly", tag: "Design inspiration" },
  { src: IMG.drapery, caption: "An estate evening beneath the trees", tag: "Design inspiration" },
  { src: IMG.stationery, caption: "Paper that feels personal", tag: "Design inspiration" },
  { src: IMG.estate, caption: "Candlelight before the house", tag: "Design inspiration" },
  { src: IMG.bouquetHands, caption: "Carried, then kept", tag: "Design inspiration" },
  { src: IMG.dance, caption: "A floor worth dancing on", tag: "Design inspiration" },
  { src: IMG.aisle, caption: "The aisle, softly lined", tag: "Design inspiration" },
  { src: IMG.reception, caption: "Long tables, low light", tag: "Design inspiration" },
  { src: IMG.embrace, caption: "Held, just for a moment", tag: "Design inspiration" },
  { src: IMG.vintageGlass, caption: "Details at eye level", tag: "Design inspiration" },
];

export const INTEREST_OPTIONS = [
  "Signage & Stationery",
  "Tablescapes & Decor",
  "Fresh Florals",
  "Perfume Bar",
  "Wedding Concierge",
  "Coat Check",
  "Dance Floor & Aisle Styling",
  "Vintage Photo Booth (Coming Soon)",
  "A Curated Collection",
];

export const PALETTES = [
  { name: "Coastal Ivory", mood: "Sea-soft neutrals, sage, and quiet light", colors: ["#F7F5EF", "#E9E3D6", "#8B9A7E", "#C9BFA8", "#33322E"] },
  { name: "Olive & Stone", mood: "The house palette — olive, stone, ivory", colors: ["#EFEAE0", "#D9D5C5", "#67672D", "#8A8A5C", "#33322E"] },
  { name: "Champagne Dusk", mood: "Warm champagne with a gilded glow", colors: ["#F6EFE4", "#EAD7BC", "#C9A87C", "#B39B78", "#2E2A24"] },
  { name: "Dusty Blue Coast", mood: "Faded sea glass and evening blue", colors: ["#EFF2F3", "#CFDBE0", "#6E8694", "#A9BCC4", "#2E3336"] },
  { name: "Garden Rose", mood: "Soft rose petals on warm plaster", colors: ["#F8F1EC", "#EAD3CB", "#B87E74", "#D3A9A0", "#3A3230"] },
  { name: "Terracotta Sun", mood: "Golden hour clay and desert light", colors: ["#F7EFE6", "#E8CDB4", "#C0754C", "#D9A87E", "#3D322B"] },
];

export const ROMAN = ["I", "II", "III", "IV", "V", "VI", "VII"];

export const HOW_IT_WORKS = [
  { step: "I", title: "Explore your options", text: "Browse the collection, the services, and the curated collections. Add whatever catches your eye to your quote list." },
  { step: "II", title: "Share your date, venue, and priorities", text: "Tell us what you are planning and what matters most. 'Still deciding' is a perfectly good answer." },
  { step: "III", title: "Review a tailored proposal", text: "We put together the details, availability, and pricing in one proposal — no guessing, no pressure." },
  { step: "IV", title: "Confirm when ready", text: "Your date and selections are confirmed only after we have agreed on the details together." },
];

export const FAQS = [
  {
    q: "How does pricing work?",
    a: "Every celebration is scoped individually. Pricing is confirmed in your tailored proposal after we review your date, venue, and the details you select. Nothing here is one-size-fits-all, so nothing here is priced by the row.",
  },
  {
    q: "Does submitting an inquiry reserve my date?",
    a: "No. Submitting an inquiry does not reserve a date or commit you to a purchase. Your date and selections are confirmed only after we have agreed on the details.",
  },
  {
    q: "Are you wedding planners?",
    a: "No — we are not a full-service wedding planner. We bring together personalized goods, coordinated decor, and staffed guest experiences, and we help you coordinate the details you choose with us.",
  },
  {
    q: "Can I ask about just one or two items?",
    a: "Of course. Some couples want a single welcome sign; others want a whole coordinated collection. Build a quote list with exactly what you love and we will take it from there.",
  },
  {
    q: "Where do you work?",
    a: "Across Southern California: coastal San Diego, North County including Vista and Escondido, Temecula, Murrieta, Winchester, Riverside, Orange County, and Los Angeles. Availability depends on your date, scope, staffing, and travel.",
  },
  {
    q: "Is the photo booth available?",
    a: "Our vintage-style photo booth is planned, not yet confirmed. You can ask about future availability and we will note your interest — it cannot be booked or paid for yet.",
  },
];

export const REGIONS = [
  { name: "San Diego & the Coast", text: "From La Jolla to Coronado and the coastal communities, celebrations shaped by sea light and soft neutrals." },
  { name: "North County", text: "Vista, Escondido, and the surrounding North San Diego County venues — gardens, ranches, and tasting rooms." },
  { name: "Temecula Valley", text: "Temecula, Murrieta, and Winchester — wine country celebrations with long tables and golden evenings." },
  { name: "Riverside", text: "Riverside and the inland communities, where garden venues and historic spaces set the tone." },
  { name: "Orange County", text: "From full coastal receptions to courtyard ceremonies across the Orange County region." },
  { name: "Los Angeles", text: "Los Angeles celebrations, from estate gardens to loft spaces, scoped individually." },
];
